<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới Khoa</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="level_id" label="Chọn phân hệ" class="form-item">
              <el-select v-model="modelData.level_id" filterable placeholder="" class="input-select">
                <el-option
                  v-for="item in lists.listLevel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên khoa" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="code" label="Mã khoa" class="form-item">
                  <el-input v-model="modelData.code" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="school_ids" label="Chọn trường học" class="form-item">
              <el-select v-model="modelData.school_ids" filterable multiple placeholder="" class="input-select-2">
                <el-option
                  v-for="item in lists.listSchool"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Khoa'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        school_ids: '',
        level_id: '',
        name: '',
        code: '',
        status: true
      },
      configData: {
        level: {
          id: 0,
          name: 'Tên khóa này'
        }
      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: []
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên khoa' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchSchool()
    this.fetchLevel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'facults-index', text: 'Khoa' },
        { name: 'facults-create', text: 'Thêm mới' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'facults-index'})
    },
    // Tải dữ liệu
    fetchSchool () {
      let data = {
        'status': 1,
        'limit': -1
      }
      axios.get('schools', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('facults', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm thành công',
              type: 'success'
            })
            this.$router.push({name: 'facults-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/facults/Create.vue